<template>
  <div>
      <div class="action-header">
        <div class="search-container">
            <div class="search-input mb-3">
                <v-text-field
                    v-model="search"
                    prepend-inner-icon="search"
                    :placeholder="this.$vuetify.lang.t('$vuetify.visitorList.searchByVisitorName')"
                    solo dense hide-details
                    height="40px"
                    @keyup.enter="searchVisitorList()">
                </v-text-field>
                <v-btn
                    class="ml-3"
                    height="40"
                    color="primary"
                    outlined
                    @click="searchVisitorList()">
                    {{ $vuetify.lang.t('$vuetify.visitorList.search') }}
                </v-btn>
            </div>
            <div class="filter-input">
                <v-select
                    @change="searchVisitorList()"
                    class="status-filter"
                    v-model="visitorStatus"
                    :items="visitorStatusDropdown"
                    item-text="text"
                    item-value="value"
                    outlined
                    dense
                    height="40"
                    background-color="#ffffff">
                </v-select>
            </div>
        </div>
        <div>
            <v-btn
                v-if="canUpdate"
                height="40"
                @click="createNewVisitor()"
                color="primary"> + {{ $vuetify.lang.t('$vuetify.visitorList.createNewVisitor') }} </v-btn>
        </div>
      </div>
      <v-card class="content-container">
          <v-data-table
            :footer-props="{
                'items-per-page-options': [10, 20, 30, 50, 100]
            }"
            @click:row="visitorInfo"
            @page-count="pageCount = $event"
            :page.sync="page"
            :headers="headers"
            :options.sync="options"
            :server-items-length="total"
            :items="visitorList"
            :empty-wrapper="false"
            :loading="loading">
            <template v-slot:[`item.status`]="{ item }">
                <div>
                    <span :class="statusStyle(item.status)">{{item.status}}</span>
                </div>
            </template>
            <template v-slot:[`item.action`]="{ item }">
                <div class="action" v-if="canUpdate">
                    <i
                        class="far fa-edit mr-2"
                        @click.stop="goToEdit(item.id)">
                    </i>
                    <i
                        class="far fa-trash-alt"
                        @click.stop="openDelete(item)">
                    </i>
                </div>
            </template>
        </v-data-table>
      </v-card>
      <!-- PAGINATION -->
      <div class="pt-2 paginator-box">
          <div>
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
          </div>
      </div>
      <!-- END PAGINATION -->
      <delete-modal
        ref="modalDelete"
        @success-deleted="deleteSuccess()"
        :deleteForm="deleteForm"/>
  </div>
</template>

<script>
import DeleteModal from '@/components/modal/DeleteModal.vue'
export default {
    name: 'VisitorLists',

    components: {
        DeleteModal
    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            visitorList: [],
            total: 0,
            loading: false,
            visitorStatus: null,
            visitorStatusDropdown: [],
            deleteForm: {
                header: '',
                content: '',
                path: ''
            },
            canUpdate: false
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.visitorList.visitorName'), value: 'fullname', width: '30%' },
                { text: this.$vuetify.lang.t('$vuetify.visitorList.contact'), value: 'email', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.visitorList.contactNo'), value: 'phone', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.visitorList.dateCreate'), value: 'created_at', width: '15%', align: 'center' },
                { text: this.$vuetify.lang.t('$vuetify.visitorList.status'), value: 'status', width: '10%', align: 'center' },
                { text: this.$vuetify.lang.t('$vuetify.visitorList.action'), value: 'action', width: '10%', align: 'center', sortable: false }
            ]
        }
    },

    methods: {
        async initVisitor () {
            await this.getStatusOptions()
            await this.getVisitorList()
        },

        statusStyle (status) {
            if (status === 'Deactive' || status === 'ปิดการใช้งาน') {
                return 'inactive-status-text'
            }
        },

        async searchVisitorList () {
            this.options.page = 1
            await this.getVisitorList()
        },

        async getStatusOptions () {
            const res = await this.axios.get('visitor/status')
            if (res && res.data && res.data.status === 'ok') {
                this.visitorStatusDropdown = res.data.data
            }
        },

        async getVisitorList () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `visitors?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            if (this.visitorStatus) {
                url += `&status=${this.visitorStatus}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.visitorList = res.data.data
                this.total = res.data.total
                this.loading = false
            }
        },

        async createNewVisitor () {
            this.$router.push({ name: 'VisitorForm' }, () => {})
        },

        goToEdit (id) {
            this.$router.push({ name: 'VisitorForm', params: { id } }, () => {})
        },

        openDelete (item) {
            this.deleteForm.header = this.$vuetify.lang.t('$vuetify.visitorList.delete')
            this.deleteForm.content = `${this.$vuetify.lang.t('$vuetify.visitorList.deleted')} ${item.fullname} ?`
            this.deleteForm.path = `visitor/delete/${item.id}`
            this.$refs.modalDelete.dialog = true
        },

        async deleteSuccess () {
            await this.getVisitorList()
            this.$notify({
                title: 'Updated',
                text: `${this.$vuetify.lang.t('$vuetify.visitorList.deleteSuccess')}`,
                type: 'success'
            })
        },

        visitorInfo (item) {
            this.$router.push({ name: 'VisitorInfo', params: { id: item.id } })
        }
    },

    async mounted () {
        this.canUpdate = await this.hasPermission(this.$constant.permission.VISITOR.UPDATE)
    },

    watch: {
        options: {
            async handler () {
                await this.initVisitor()
            },
            deep: true
        },
        '$vuetify.lang.current': {
            handler: async function () {
                await this.getStatusOptions()
                await this.getVisitorList()
            },
            deep: true
        }
    }

}
</script>

<style lang="scss" scoped>
.search-container {
    ::v-deep .v-input__control > .v-input__slot {
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
        box-shadow: none !important;
        border: 1px solid #a8a8a8 !important;
        width: 340px;
    }

    ::v-deep .status-filter {
        .v-input__control > .v-input__slot {
            border: none !important;
            width: 200px;
        }

        .v-select__selection{
            line-height: 1.75;
        }
    }
}
.inactive-status-text {
    color: #ff544a;
}

::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin: 0 !important;
}

::v-deep .theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #eeeeee;
    cursor: pointer;
}
</style>
